import { oneOf } from 'prop-types';

export default oneOf([
  'equivalents',
  'streaming',
  'downloads',
  'track_downloads',
  'album_downloads',
  'physical',
]);
